import React from 'react';
import QuestionBox from "./QuestionBox/QuestionBox";
import QuizFooter from "./QuizFooter/QuizFooter";
import { useSelector } from "react-redux";

/**
 * Question box with footer
 * @param props
 * @returns {*}
 * @constructor
 */
const QuestionPlayground = props => {
    const {
        mode, isLoading, drawerToggle, viewMode, handleClick, toggleClick, handlerOpenCheckScore,
        handleQuizPauseChange
    } = props;
    const total = useSelector((state) => state.quiz.totalQuestions);
    const activeQuestionIndex = useSelector((state) => state.activeQuestionIndex);
    return (
        <React.Fragment>
            <QuestionBox mode={mode} isLoading={isLoading}
                         drawerToggle={drawerToggle}
                         viewMode={viewMode}
                         activeQuestionIndex={activeQuestionIndex}
                         handleClick={toggleClick}
                         total={total}
                         number={activeQuestionIndex + 1}/>
            <QuizFooter mode={mode} viewMode={viewMode} hideNext={activeQuestionIndex === (total - 1)}
                        drawerToggle={drawerToggle}
                        handlerOpenCheckScore={handlerOpenCheckScore}
                        hidePrev={activeQuestionIndex === 0}
                        handleClick={handleClick}
                        activeQuestionIndex={activeQuestionIndex}
                        handleQuizPauseChange={handleQuizPauseChange}/>
        </React.Fragment>
    );
};

export default QuestionPlayground;
